import type { AppOperatingSystem } from "../types/commonFiltersDto";

export { RANGE_SELECT_WIDTH } from "../components/filters/AppDownloadEngagementFilter/const";

export const SELECTED_ALL_PREFIX = "All";

export const DOLLAR_PREFIX = "$";

export const COUNTRY_SELECT_WIDTH = 263;

export const appOsToStoreMap: Record<AppOperatingSystem, "google" | "apple"> = {
    android: "google",
    ios: "apple",
};
